import {COMPLETE, FAIL, TASK_START} from '@megaphonenpm/mputils/src/constants.js';
import {PostMessages} from './PostMessages.js';
import {MegaScreen} from './MegaScreen.js';
import {getAssetTypeFromURI} from '@megaphonenpm/mputils/src/utils.js';

export class AssetStatusHostNotifier {
  constructor (mediaCache) {
    mediaCache.on(TASK_START, this.taskStartListener.bind(this));
  }

  taskStartListener (e) {
    let loadTask = e.detail.task;
    loadTask.on(COMPLETE, this.taskResolvedListener);
    loadTask.on(FAIL, this.taskResolvedListener);

    // The type isn't known until the asset finishes downloading, so infer the best guess based on
    // file extension.
    let type = getAssetTypeFromURI(loadTask.url);

    MegaScreen.globals.postMessageManager.send({
      message: PostMessages.ASSET_DOWNLOAD_START,
      data: {
        url: loadTask.url,
        type: type
      }
    });
  }

  taskResolvedListener (e) {
    let loadTask = e.detail.target;

    loadTask.off(COMPLETE, this.taskResolvedListener);
    loadTask.off(FAIL, this.taskResolvedListener);

    MegaScreen.globals.postMessageManager.send({
      message: PostMessages.ASSET_DOWNLOAD_END,
      data: {
        url: loadTask.url,
        type: loadTask.type
      }
    });
  }
}
